import moment from 'moment';

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

// export function encodeBase64(data) {
//     if (typeof btoa === "function") {
//         return btoa(data);
//     } else if (typeof Buffer === "function") {
//         return Buffer.from(data, "utf-8").toString("base64");
//     } else {
//         throw new Error("Failed to determine the platform specific encoder");
//     }
// }

export function decodeBase64(data:string) {
    if (typeof atob === "function") {
        return atob(data);
    } else if (typeof Buffer === "function") {
        return Buffer.from(data, "base64").toString("utf-8");
    } else {
        throw new Error("Failed to determine the platform specific decoder");
    }
}

export function segmentToInstrumentType(segment:string) {
    segment = segment.toString().toLowerCase()
    const data:Record<string,string> = {nse_eq: 'nse',nse_fo: 'nfo',nse_cur: 'cds',mcx_fo: 'mcx', bse_eq: 'bse', bse_fo: 'bfo'}
    return  data[segment]
}
export function exchangeToMarketSegmentId(exchange:string) {
    exchange = exchange.toString().toLowerCase()
    const data:Record<string,number> = {nse_eq: 1,nse_fo: 2,nse_cur: 13,mcx_fo: 4,bse_eq: 3,bse_fo: 4}
    return  data[exchange]
}

export function numDifferentiation(value:string) {
    var val = Math.abs(Number(value));
    var final = '';
    if (val >= 10000000) {
        value = (val / 10000000).toFixed(2);
        final = value + 'Cr';
    } else if (val >= 100000) {
        value = (val / 100000).toFixed(2);
        final = value + 'L';
    } else if (val >= 1000) {
        value = (val / 1000).toFixed(2);
        final = value + 'K';
    }else{
        final = '' + val;
    }
    return final;
}

// export const  getCloseNumber = (goal,array)  => {
//     return array.reduce(function(prev, curr) {
//         return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
//     },0);
// }

export function createElementFromHTML(htmlString:string) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

// export var regularExpression = /^(?=.*[0-9])(?=.*[!@#<>?$":_`~;[]|=+()*&^%-])[a-zA-Z0-9!@#<>?":_`~;[]|=+()*&^%-]{8,16}$/;

export var regularExpression = /^(?=.*\d{1})(?=.*[a-z]{1})(?=.*[A-Z]{1})(?=.*[!@#$%^&*{|}?~_=+.-]{1})(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/;

export const getBrowserDetails = () => {
    const { userAgent } = navigator;
  
    let browserName = 'Unknown';
    let fullVersion = 'Unknown';
  
    if (/edg/i.test(userAgent)) {
      browserName = 'Edge';
      fullVersion = userAgent.match(/(?:edg|edge)\/([\d.]+)/i)?.[1] || 'Unknown';
    } else if (/chrome|crios|crmo/i.test(userAgent)) {
      browserName = 'Chrome';
      fullVersion = userAgent.match(/(?:chrome|crios|crmo)\/([\d.]+)/i)?.[1] || '';
    } else if (/firefox|fxios/i.test(userAgent)) {
      browserName = 'Firefox';
      fullVersion = userAgent.match(/(?:firefox|fxios)\/([\d.]+)/i)?.[1] || '';
    } else if (/safari/i.test(userAgent)) {
      browserName = 'Safari';
      fullVersion = userAgent.match(/version\/([\d.]+)/i)?.[1] || '';
    }
  
    const OSName = /windows nt/i.test(userAgent) ? 'Windows' :
               /macintosh|mac os x/i.test(userAgent) ? 'macOS' :
               /android/i.test(userAgent) ? 'Android' :
               /iphone|ipad|ipod/i.test(userAgent) ? 'iOS' :
               /linux/i.test(userAgent) ? 'Linux' : 'Unknown';
  
    return { browserName, fullVersion, OSName };
  };
  



export function formatdate(date:string){
    let now = moment(date, "YYYYMMDD").format('DD MMM YYYY');
    return now
}

export function formatdateDDMM(date:string){
    let now = moment(date, "YYYYMMDD").format('DD MMM');
    return now
}